import { render, staticRenderFns } from "./register-result.vue?vue&type=template&id=0a99729d&scoped=true&"
import script from "./register-result.vue?vue&type=script&lang=js&"
export * from "./register-result.vue?vue&type=script&lang=js&"
import style0 from "./register-result.vue?vue&type=style&index=0&id=0a99729d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a99729d",
  null
  
)

export default component.exports